export const BACKTEST_RUNNING = 'BACKTEST_RUNNING';
export const BACKTEST_COMPLETED = 'BACKTEST_COMPLETED';
export const BACKTEST_WITH_ERROR = 'BACKTEST_WITH_ERROR';
export const BACKTEST_CANCELLED = 'BACKTEST_CANCELLED';
export const BACKTEST_SAVED = 'BACKTEST_SAVED';
